export default {
    values: {
        Edit: 'Editar',
        Enable: 'Habilitar',
        Disable: 'Desabilitar',
        Activate: 'Ativar',
        Packages: 'Pacotes',
        Configure: 'Configurar',
        Properties: 'Propriedades',
        'Dashboard Name': 'Nome do dashboard',
        'Dashboard selection': 'Seleção de Dashboard',
        'General settings': 'Configurações gerais',
        'Create new dashboard': 'Criar novo dashboard',
        'No options available': 'Nenhuma opção disponível',
        'For security reasons, only': 'Por motivos de segurança, somente',
        'Overwrite dashboard selection': 'Sobrescrever dashboard selecionado',
        Features: 'Funcionalidades',
        'Selected dashboard': 'Dashboard selecionado',
        'This feature is not currently installed': 'Essa funcionalidade ainda não foi instalada',
        '%{dashboards} Dashboards': '%{dashboards} Dashboards',
        'To enable a dashboard, first select a perspective.':
            'Para habilitar um dashboard, primeiro selecione uma perspectiva',
        'For more details, go to the ': 'Para mais detalhes, vá para a ',
        'plugins screen': 'tela de plugins',
        Validation: 'Validação',
        'pespective must not be empty': 'perspectiva não pode ser nula',
        'Search packages': 'Buscar pacotes',
        'No packages found': 'Nenhum pacote encontrado',
        'Package successfully deleted.': 'Pacote removido com sucesso',
        'Are you sure you want remove the package "%{packageName}"':
            'Tem certeza que deseja excluir o pacote "%{packageName}"',
        'This action cannot be undone and the associated plugin will also be removed':
            'Essa ação não poderá ser desfeita e o plugin associado também será removido',
        'If you really want to remove it, type': 'Se realmente deseja excluir a instância, digite',
        'in the field below before completing the action': 'no campo abaixo para completar a ação',
        Remove: 'Excluir',
        'New feature added to the package': 'Nova funcionalidade adicionada ao package',
        'To enable this feature, first select a perspective':
            'Para habilitar essa funcionalidade, primeiro selecione uma perspectiva',
        'Remove "%{packageName}"': 'Excluir "%{packageName}"',
        'Required plugins': 'Plugins necessários',
        'feature_type_card_title.DASHBOARD': 'Dashboards',
        'feature_type_card_title.RULE': 'Regras',
        'feature_type_card_title.DATASOURCE': 'Datasources',
        'feature_type_card_title.PIPES_MODULE': 'Pipes modules',
        'feature_type_card_title.JS_SNIPPET': 'JS Snippets',
        'feature_type_card_title.CSS_SNIPPET': 'CSS Snippets',
        'feature_type_card_title.GROOVY_SNIPPET': 'Groovy Snippets',
        'feature_type_card_title.LOOKUP_TABLE': 'Lookup Tables',
        'feature_type_card_title.DASHBOARD_TEMPLATE': 'Dashboard Templates',
        'feature_type.DASHBOARD': 'Dashboard',
        'feature_type.RULE': 'Rule',
        'feature_type.DATASOURCE': 'Datasource',
        'feature_type.PIPES_MODULE': 'Pipes module',
        'feature_type.JS_SNIPPET': 'JS Snippet',
        'feature_type.CSS_SNIPPET': 'CSS Snippet',
        'feature_type.GROOVY_SNIPPET': 'Groovy Snippet',
        'feature_type.LOOKUP_TABLE': 'Lookup Table',
        'feature_type.DASHBOARD_TEMPLATE': 'Dashboard Template',
        'feature_type.PIPES_2_STATE': 'Pipes 2 State',
        'feature_type_card_title.PIPES_2_STATE': 'Pipes 2 State',
        'feature_type_card_title.LOOKUP_PIPES': 'Lookup Pipes',
        Inactive: 'Inativo',
        Active: 'Ativo',
        'Feature installed': 'Funcionalidade instalada',
        'Installed object with invalid status': 'Objeto instalado com status inválido',
        'Enabled but not installed': 'Habilitada mas não instalada',
        'Feature not installed because the package is INACTIVE':
            'Funcionalidade não instalada porque pacote está INATIVO',
        'Search by feature name': 'Pesquisar por nome da funcionalidade',
        'Loading...': 'Carregando...',
        'Installed packages': 'Pacotes instalados',
        'Package: %{title}': 'Pacote: %{title}',
        "This feature doesn't have a changelog.": 'Esta funcionalidade não possui uma lista de mudanças.',
        "What's New?": 'O que há de novo?',
        'Hide older versions': 'Esconder versões mais antigas',
        'View older versions': 'Ver versões mais antigas',
        'Version constraint': 'Restrição de versão',
        'You are trying to enable the feature': 'Você está tentando habilitar a funcionalidade',
        'You are trying to disable the feature': 'Você está tentando desabilitar a funcionalidade',
        'This will prevent users from accessing the feature': 'Isso impedirá que usários utilizem a funcionalidade',
        'Are you sure you want to proceed with this action': 'Você tem certeza que deseja prosseguir com esta ação',
        'Dashboard is still visible for user': 'O dashboard ainda está visível para o usuário que ativou este pacote',
        'This will overwrite any existing data or widgets on the selected dashboard':
            'Isso irá sobrescrever qualquer dado ou widgets existentes',
        'This will create a new empty dashboard with the new dashboard configuration':
            'Será criado um novo dashboard vazio com as novas configurações do dashboard',
        'Changing current selected dashboard will overwrite any existing data or widgets':
            'Atualizar o dashboard selecionado irá sobrescrever qualquer dado ou widgets existentes',
        'Changing current selected perspective will affect current users of this feature':
            'Alterar a perspectiva selecionada irá afetar usuários dessa funcionalidade',
        'with the same name as defined in the package manifest are displayed':
            'com o mesmo nome definido no manifesto do pacote são exibidos',
        'Changing the currently selected perspective will impact all users who are currently using this feature':
            'Alterar a perspectiva selecionada irá impactar todos os usuários que atualmente usam essa funcionalidade',
        missing_plugin_id_msg: ({ plugin }) =>
            `O pacote foi removido, mas o plugin respectivo (${plugin}) não pois ele não foi encontrado; se ele realmente ainda existe, é possível que o pacote seja automaticamente registrado novamente quando o Live reiniciar ou outros plugins forem modificados`,
        'Sorry, it was not possible to delete the package settings.': 'Não foi possível remover o pacote.',
        'This dashboard may still be visible to superusers and to the first user who enabled it.':
            'Esse dashboard ainda pode estar visível para superusuários e para o usuário que o ativou pela primeira vez.'
    }
}
